import colors from 'vuetify/lib/util/colors';


export default {
  light: {
    primary: '#be1622',
    secondary: colors.indigo
  },
  dark: {
    primary: '#be1622',
    secondary: colors.indigo
  }
};

/*
\see https://vuetifyjs.com/en/customization/theme

{
  light: {
    primary: '#3f51b5',
    secondary: '#b0bec5',
    anchor: '#8c9eff',
  }
}

{
  light: {
    primary: {
      base: colors.purple.base,
      darken1: colors.purple.darken2,
    },
    secondary: colors.indigo,
    // All keys will generate theme styles,
    // Here we add a custom `tertiary` color
    tertiary: colors.pink.base
  }
}

*/
